import checkboxTicked from '../../img/icons/checked.svg';
import checkboxEmpty from '../../img/icons/checkboxempty.svg';
import { getPeppers } from '../../features/menu/components/CustomiseCard';
import React, { useState } from 'react';
import Cross from '../shared/Cross';
import { RequiredTag } from '../RequiredTag';

export const ChoiceModal = ({ state, onClose, isMobileModal, confirmButtonText = 'Add to basket' }) => {
  const [selectedId, setSelectedId] = useState(state.prePopulatedChoiceId);
  const [errorState, setErrorState] = useState(state.prePopulatedChoiceId ? { isErrored: false, hasInteracted: true } : false);
  const handleAdd = () => {
    if (!selectedId) {
      setErrorState({ isErrored: true, hasInteracted: true });
      return;
    }
    state.resolve(selectedId);
    onClose();
  };

  const handleClose = () => {
    state.reject();
    onClose();
  }

  const handleSelected = (id) => {
    setSelectedId(id);
    setErrorState(es => ({ ...es, isErrored: false, hasInteracted: true }));
  };

  return (
    <div className='choice-modal'>
      {!isMobileModal &&
        <Cross onClick={handleClose} absolute rightPosition={16} topPosition={16} />
      }
      {isMobileModal &&
        <div className='choice-modal-title-container'>
          <div className='choice-modal-header-mobile-wrapper'>
            <h1 className='choice-modal-header' data-testid='closeiframe-modal-heading'>
              {state.question?.name}
            </h1>
            <RequiredTag isErrored={errorState?.isErrored} showValidation={errorState?.hasInteracted} />
          </div>
          <p>Select one of the options below.</p>
        </div>
      }
      {!isMobileModal &&
        <div className='choice-modal-title-container'>
          <h1 className='choice-modal-header' data-testid='closeiframe-modal-heading'>
            {state.question?.name}
          </h1>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexShrink: 1 }}>
            <p style={{ fontSize: 18 }}>Select one of the options below.</p>
            <RequiredTag isErrored={errorState?.isErrored} showValidation={errorState?.hasInteracted} />
          </div>
        </div>
      }
      <div className='choice-modal-option-container'>
        <div className='choice-modal-option-list-container'>
          {
            state?.choices?.map((choice, idx) => <OptionCard choice={choice} selected={selectedId === choice.id} setSelected={handleSelected} key={idx} />)
          }
        </div>
        <button className='btn btn-primary' onClick={handleAdd} >{confirmButtonText}</button>
      </div>
    </div>
  );
};

const OptionCard = ({ choice, selected, setSelected }) => (
  <div
    className='choice-modal-option-card'
    onClick={() => setSelected(choice.id)}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      {
        (selected) ?
          <img src={checkboxTicked} className="icon is-medium" data-testid='choice-selected' width={42} />
          :
          <img src={checkboxEmpty} className="icon is-medium" data-testid='choice-unselected' role='icon' width={42} />
      }
      <p className='choice-modal-option-choice-name' data-testid='choice-name'>{choice.name}</p>
    </div>
    {
      choice.cost ? <p className='choice-price'>{choice.cost.toFixed(2)}</p> : <></>
    }
    {getPeppers(choice.uiTags)}
  </div>
);